import {
  ArchiveTickIcon_default
} from "./chunk-WY6GRQUH.mjs";
export {
  ArchiveTickIcon_default as default
};
